import { Box, Typography } from '@mui/material';
import { FaChevronRight } from "react-icons/fa";


function Breadcrumb({ title, subtitle }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>

      {/* 1. Projects */}
      <Typography
        className='input-label'
        sx={{
          fontSize: '16px',
          cursor: 'pointer',
        }}
      >
        {title}
      </Typography>

      {/* 2. Separator */}
      <Box className="input-label" sx={{ mx: 1, display: 'flex', alignItems: 'center' }}>
        <FaChevronRight size={18} strokeWidth={3.5} />
      </Box>

      {/* 3. Task and progress */}
      <Typography className="input-label" sx={{ fontSize: '16px', fontWeight: 500 }}>
        {subtitle}
      </Typography>

    </Box>
  );
}
export default Breadcrumb;